import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/icon-close-white.svg")